export const IF_OF_PERFORMANCE_GAMETYPE_KEY = 'key-defPerformance-ifOfTable';
export const IF_OF_TABLE_NAME = 'IF/OF Defense Performance';
export const IF_OF_TABLE_ID = 'if-of-defense-performance';

export const CATCHER_PERFORMANCE_GAMETYPE_KEY = 'key-defPerformance-catcherTable';
export const CATCHER_TABLE_NAME = 'Catcher Defense Performance';
export const CATCHER_TABLE_ID = 'catcher-defense-performance';

export const CATCHER_PROCESS_GAMETYPE_KEY = 'key-defProcess-catcherTable';
export const CATCHER_PROCESS_TABLE_NAME = 'Catcher Process';
export const CATCHER_PROCESS_TABLE_ID = 'catcher-defense-process';

export const OF_POSITIONS = ['LF', 'CF', 'RF'];
export const OF_OPINION_TABLE_NAME = 'OF Defense Opinions';
export const OF_OPINION_TABLE_ID = 'of-defense-opinions';

export const IF_OF_OPINION_STATS_ARRAY = ['NonRg', 'DPR', 'Scoop', 'UZR', 'DRS'];
export const IF_OF_OPINION_STATS_IGNORE_ARRAY = [
  'TOPS4Percent',
  'ThrowNumThrows',
  'ThrowMaxVelo',
  'ThrowAvgExch',
  'ThrowAvgVelo',
];

export const IF_POSITIONS = ['1B', '3B', '2B', 'SS'];
export const IF_OPINION_TABLE_NAME = 'IF Defense Opinions';
export const IF_OPINION_TABLE_ID = 'if-defense-opinions';

export const DEFENSE_GRID_TABLE_NAME = 'Defense Grid';
export const DEFENSE_GRID_TABLE_ID = 'general-defense-grid';
export const DEFENSE_GRID_POSITIONS = [
  {
    name: 'C',
    thinRightBorder: true,
  },
  {
    name: '1B',
    thinRightBorder: false,
  },
  {
    name: '2B',
    thinRightBorder: false,
  },
  {
    name: 'SS',
    thinRightBorder: false,
  },
  {
    name: '3B',
    thinRightBorder: true,
  },
  {
    name: 'LF',
    thinRightBorder: false,
  },
  {
    name: 'CF',
    thinRightBorder: false,
  },
  {
    name: 'RF',
    thinRightBorder: true,
  },
  {
    name: 'DH',
    thinRightBorder: false,
  },
];
export const DEFENSE_GRID_COLGROUP_DEFS = [
  {
    label: 'Proj',
    val: 2,
    totalPropName: 'xFRAA',
    totalPropHeader: 'xFRAA',
    propertyPrefix: 'x',
  },
  {
    label: 'UnReg',
    val: 0,
    totalPropName: 'UnRegFRAA',
    totalPropHeader: 'UnReg FRAA',
    propertyPrefix: 'UnReg',
  },
  {
    label: 'Reg',
    val: 1,
    totalPropName: 'RegFRAA',
    totalPropHeader: 'Reg FRAA',
    propertyPrefix: 'Reg',
  },
  {
    label: 'TOPS',
    val: 3,
    totalPropName: 'TOPS',
    totalPropHeader: 'TOPS',
    propertyPrefix: 'TOPS',
  },
  {
    label: 'SHOE',
    val: 4,
    totalPropName: 'Shoe',
    totalPropHeader: 'SHOE',
    propertyPrefix: 'Shoe',
  },
];

export const DEFENSE_GRID_GAME_OPTIONS = [
  {
    label: 'Games Played',
    val: 0,
  },
  {
    label: 'Games Started',
    val: 1,
  },
  {
    label: 'Innings Played',
    val: 2,
  },
];

export const GROUP_BY_OPTIONS = [
  {
    label: 'Stint',
    val: 0,
  },
  {
    label: 'Year',
    val: 1,
  },
  {
    label: 'Year/Level',
    val: 2,
  },
  {
    label: 'Year Maj./Min.',
    val: 3,
  },
];

export const ORDER_BY_OPTIONS = [
  {
    label: 'Year',
    val: 'Season',
  },
  {
    label: 'Pos',
    val: 'Pos',
  },
];

export const PER_150_OPTIONS = [
  {
    label: 'Cumul.',
    val: 0,
  },
  {
    label: 'Per150',
    val: 1,
  },
];

export const TOPS_OPTIONS = [
  {
    label: 'TOPS4',
    val: 'TOPS4',
  },
  {
    label: 'TOPS3',
    val: 'TOPS3',
  },
];
